import React, { useState } from "react";
import {Button, Dialog, DialogTitle, DialogContent, DialogContentText, TextField, DialogActions} from "@material-ui/core"
import { AssetCategoryType } from '../../../../entities/AssetType';
import { FieldValidationError, ValidationHelper } from "../../../../services/server/ServerResponses";
import { useLibrary, useLibraryAlert } from "../../LibraryPage";
import { BuilderAssetService, SaveBuilderAssetRequest } from "../../../../services/BuilderAssetService";
import { UserAgent } from "../../../../utilities/UserAgent";
import { toAssetCategory } from "../../../../entities/AssetCategory";
import { useHistory } from "react-router-dom";
import { routes } from "../../../../routes";

interface Props {
    open: boolean;
    onClose: () => void;
    selectedAssetType: AssetCategoryType;
}

export function CreateAssetDialog(props:Props) {
    const {open, selectedAssetType } = props;
    const context = useLibrary();
    const libraryAlert = useLibraryAlert();
    const history = useHistory();

    const [title, setTitle] = useState("");
    const [errors, setErrors] = useState<FieldValidationError[]>([]);
    const [disabled, setDisabled] = useState(false);

    const handleAdd = async(e:React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if(title.length === 0)
            return setErrors([{field: "Name", errors: ["Invalid Name"]}])

        const request: SaveBuilderAssetRequest = {
            parentId: context.activeFolderId ?? undefined,
			name: title,
			isStarred: false,
			dateAccessed: new Date(),
			category: toAssetCategory(selectedAssetType.category),
			text: "",
			slideCount: 0,
			isTemplate: false,
			templateDescription: "",
			slideExporterAspectRatio: undefined,
			customSlideBackgroundImagePath: undefined,
			offlineMode: false,
			lastModifiedFormFactor: UserAgent.getFormFactor(),
			lastModifiedOnOperatingSystem: UserAgent.getOperatingSystem(),
		};
        
        setDisabled(true)
		const response = await BuilderAssetService.save(request);
        setDisabled(false)

        if(response.error) return libraryAlert(response.message);
        if(response.validation) return setErrors(response.errors);

        history.push(routes.app.resolve.builderPage(response.data.id), { prevUrl: window.location.href });
    }
    
    return (
        <Dialog
            open={open}
            onClose={props.onClose}
            disableBackdropClick={disabled}
            disableEscapeKeyDown={disabled}
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title">New {selectedAssetType.name}</DialogTitle>
            <form onSubmit={handleAdd}>
                <DialogContent>
                    <DialogContentText>
                        Enter the name of your new {selectedAssetType.name}.
                    </DialogContentText>
                    <TextField
                        required
                        autoFocus={true}
                        margin="dense"
                        id="newItemName"
                        label="Name"
                        type="text"
                        onChange={(e) => setTitle(e.currentTarget.value)}
                        value={title}
                        fullWidth
                        error={ValidationHelper.isFieldInError(errors, 'Name')}
                        helperText={<span dangerouslySetInnerHTML={{ __html: ValidationHelper.getFieldErrorSummary(errors, 'Name') }} />}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.onClose} color="primary" disabled={disabled}>
                        Cancel
                    </Button>
                    <Button type="submit" color="primary" disabled={disabled}>
                        Add
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}
